import OrderSheet from "routes/Order/OrderSheet";
import OrderHistory from "routes/Order/OrderHistory";
import OrderDetail from "routes/Order/OrderDetail";

const orderRoutes = [
    {
        path: "order",
        children: [
            {
                path: "ordersheet",
                element: <OrderSheet />,
            },
            {
                path: "history",
                element: <OrderHistory />,
            },
            {
                path: "orderdetail/:orderid",
                element: <OrderDetail />,
            },
        ],
    },
];

export default orderRoutes;
